import { Component, Input, OnInit } from '@angular/core';
import { SetNumeri } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-card-counter',
  templateUrl: './card-counter.component.html',
  styleUrls: ['./card-counter.component.scss']
})
export class CardCounterComponent implements OnInit {

  @Input() block: SetNumeri = {} as SetNumeri;
  @Input() isActiveCarousel: boolean = true;
  @Input() idSlide: string = '';

  public domainWebsite = environment.urlApi;
  public imgPath: string = '';

  constructor(private helperService: HelpersService) { }

  ngOnInit(): void {
    this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.block.immagine, "src");
  }

}
